module.exports = __webpack_public_path__ + "static/artist-hero25-ba91802a543a98fddba4503f6beceae4.jpg";